/**
 * The entity stores tags as text[], the form edits a comma-separated string. This
 * expression was duplicated inline in every page's create and update handler; its
 * absence on one side of the pair is what silently broke category editing.
 */
export function splitTags(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map((tag) => String(tag).trim()).filter(Boolean);
  }
  if (typeof value === 'string') {
    return value
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
  }
  return [];
}
